import { ProviderFile, ProviderDefinition, DataPoint } from "fileParsing/types";
import { PayloadAction } from "@reduxjs/toolkit";

// Action types definition
export enum DataActionTypes {
  ADD_DATA = "@@data/ADD_DATA",
  UPDATE_DATA = "@@data/UPDATE_DATA",
  UPDATE_PROPERTIES = "@@data/UPDATE_PROPERTIES",
  REMOVE_DATA = "@@data/REMOVE_DATA",
  SWITCH_ITEM = "@@data/SWITCH_ITEM",
  RENAME_EXPORT = "@@data/RENAME_EXPORT",
  SET_PRIVACY_SENSITIVITY = "@@data/SET_PRIVACY_SENSITIVITY",
}

// State definition
export type DataState = {
  readonly providers: ProviderDefinition[];
  readonly exports: ParsedExport[];
  readonly counter: number;
};

export type FileProperties = {
  fileName: string;
  fileSize: number;
};

export type ParsedExport = {
  id: number;
  fileProperties: FileProperties;
  providerId: string;
  properties: {
    providerName: string;
    originalProviderName: string;
    author: string;
    url: string;
    helpEn: string[];
    helpDe: string[];
  };
  active: boolean;
  workerId: string;
  children: ProviderFile[];
  datapoints: DataPoint[];
};

// Actions definition
export type SetAddDataAction = PayloadAction<
  { fileProperties: FileProperties; providerId: string; workerId: string },
  DataActionTypes.ADD_DATA
>;
export type SetUpdateDataAction = PayloadAction<
  { exportId: number; fileId: number; data: ProviderFile },
  DataActionTypes.UPDATE_DATA
>;
export type SetUpdatePropertiesAction = PayloadAction<
  {
    exportId: number;
    providerName: string;
    author: string;
    url: string;
    helpEn: string[];
    helpDe: string[];
  },
  DataActionTypes.UPDATE_PROPERTIES
>;
export type SetRemoveDataAction = PayloadAction<{ exportId: number }, DataActionTypes.REMOVE_DATA>;
export type SetSwitchItemAction = PayloadAction<number, DataActionTypes.SWITCH_ITEM>;
export type SetRenameExportAction = PayloadAction<{ exportId: number; newName: string }, DataActionTypes.RENAME_EXPORT>;
export type SePrivacySensitivityAction = PayloadAction<
  { exportId: number; fileId: number; index: number; value: number },
  DataActionTypes.SET_PRIVACY_SENSITIVITY
>;

export type DataActions =
  | SetAddDataAction
  | SetUpdateDataAction
  | SetUpdateDataAction
  | SetUpdatePropertiesAction
  | SetRemoveDataAction
  | SetSwitchItemAction
  | SetRenameExportAction
  | SePrivacySensitivityAction;
